import { render, staticRenderFns } from "./sendRevision.vue?vue&type=template&id=0ac78ea0&"
import script from "./sendRevision.vue?vue&type=script&lang=js&"
export * from "./sendRevision.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports